import React, { useCallback, useEffect, useRef, useState } from 'react';

import Image from './Image/Image';
import MenuButton from './menu/MenuButton';
import ScrollView from '../components/ScrollView/ScrollView';
import LeftNavigation from '../elements/LeftNavigation';
import SoundButton from '../elements/SoundButton';

import Intro1 from './intro/Intro1/Intro1';
import Intro2 from './intro/Intro2/Intro2';
import Intro3 from './intro/Intro3/Intro3';
import TitlePage from './title/Title';
import TellMeAJoke from './intro/TellMeAJoke/TellMeAJoke';
import TheJoke from './joke/Joke/TheJoke';
import Conclusion from './conclusion/Conclusion/Conclusion';
import About from './conclusion/About/About';
import TheScience from './joke/TheScience/TheScience';

import { useNavigationContext } from '../context/NavigationContext';
import { useAnimationContext } from '../context/AnimationContext';
import { ConclusionPages, IntroductionPages, SectionData, SectionIDs } from '../data/Sections';

import styles from './styles.module.scss';
import TheJokeVideo from './theJokeVideo';

export default function ScrollableContent(): JSX.Element {
  const { sections, activeSectionID, setScrollEnabledUp, setScrollEnabledDown } = useNavigationContext();
  const { AddAnimationGroup } = useAnimationContext();
  const [ isPagesInitialized, setIsPagesInitialized ] = useState(false);

  const videoRef = useRef<HTMLVideoElement>();

  const { moveToTheSection } = useNavigationContext();
  const gotoTitlePage = useCallback(
    () => {
      moveToTheSection(SectionIDs.Title);
    },
    [moveToTheSection],
  );
  // initialize primary animation groups based on the sections
  useEffect(() =>
  {
    sections.forEach((section: SectionData) =>
    {
      AddAnimationGroup({
        id: section.id,
        start: section.start,
        end: section.end,
        animations: []
      });
    });
    setIsPagesInitialized(true);
  }, [ sections, AddAnimationGroup ]);

  useEffect(() => {
    switch (activeSectionID) {
    case SectionIDs.Intro1:
    case SectionIDs.Intro2:
    case SectionIDs.Intro3:
    case SectionIDs.Conclusion:
      setScrollEnabledUp(true);
      setScrollEnabledDown(true);
      break;
    case SectionIDs.Title:
    case SectionIDs.TellMeAJoke:
    case SectionIDs.Science:
      setScrollEnabledUp(true);
      setScrollEnabledDown(false);
      break;
    case SectionIDs.About:
    case SectionIDs.Joke:
      setScrollEnabledUp(false);
      setScrollEnabledDown(false);
      break;
    default:
      break;
    }
  }, [activeSectionID, setScrollEnabledUp, setScrollEnabledDown]);


  if (!isPagesInitialized)
    return <></>;

  return (<div className={'contentDOM'}>
    <Intro1 sectionID={SectionIDs.Intro1}/>
    <Intro2 sectionID={SectionIDs.Intro2}/>
    <Intro3 sectionID={SectionIDs.Intro3}/>
    <TitlePage sectionID={SectionIDs.Title}/>
    <TellMeAJoke sectionID={SectionIDs.TellMeAJoke} video={videoRef.current} />
    <TheJoke sectionID={SectionIDs.Joke}  video={videoRef.current} />
    <TheScience sectionID={SectionIDs.Science}></TheScience>
    <Conclusion sectionID={SectionIDs.Conclusion}></Conclusion>
    {/* <DonateAJoke sectionID={SectionIDs.Donate}></DonateAJoke> */}
    <About sectionID={SectionIDs.About}></About>
    {
      (IntroductionPages.includes(activeSectionID)
      || ConclusionPages.includes(activeSectionID))
      && <ScrollView />
    }
    <TheJokeVideo ref={videoRef} />
    <LeftNavigation></LeftNavigation>
    <SoundButton></SoundButton>
    <MenuButton video={videoRef.current}></MenuButton>
    <button onClick={gotoTitlePage} className={styles.logo}>
      <Image
        alt='logo'
        filename='logo'
        lazy={false}
        imageConfig={{
          '(min-width: 900px)': {
            sizes: {
              '1x': 'lg-1x',
              '2x': 'lg-2x',
            },
            type: 'jpg'
          },
          '(min-width: 600px)': {
            sizes: {
              '1x': 'md-1x',
              '2x': 'md-2x',
            },
            type: 'jpg'
          },
          '(max-width: 599px)': {
            sizes: {
              '1x': 'sm-1x',
              '2x': 'sm-2x',
            },
            type: 'jpg'
          }
        }} />
    </button>
  </div>);
}
